module.exports={
  "The Global Goals": "VerdensmÃ¥l",
  "For Sustainable Development": "Danmarks officielle side"
}
